import React from 'react'

import { truncateText } from '../../lib/helpers/helperFunctions'
import { CompanyTypeCode } from '../../types/misc'
import CompanyLogoOrName from './CompanyLogoOrName'

interface Props {
  company: Company
  renderCompanyName?: (company: Company) => React.ReactNode
}

interface Company {
  logoUrl?: string | null
  presentationName: string
  companyTypeCode: CompanyTypeCode
}

const CompanyLogoOrNameTableCell: React.FC<Props> = ({
  company,
  renderCompanyName,
}) => (
  <div className="d-flex align-items-center" style={{ gap: '12px' }}>
    <div
      className="d-flex flex-shrink-0 justify-content-center align-items-center"
      style={{ width: '50px', height: '40px' }}
    >
      <CompanyLogoOrName
        name={company.presentationName}
        logoUrl={company.logoUrl}
        imageStyle={{ maxHeight: '30px', maxWidth: '40px' }}
        companyTypeCode={company.companyTypeCode}
        showNameFallback={false}
      />
    </div>

    {renderCompanyName ? (
      renderCompanyName(company)
    ) : (
      <>{truncateText(company.presentationName, { maxLength: 50 })}</>
    )}
  </div>
)

export default CompanyLogoOrNameTableCell
